export const FETCH_BRAND_PAGE_DETAILS_BEGIN = 'FETCH_BRAND_PAGE_DETAILS_BEGIN';
export const FETCH_BRAND_PAGE_DETAILS_SUCCESS = 'FETCH_BRAND_PAGE_DETAILS_SUCCESS';
export const FETCH_BRAND_PAGE_DETAILS_FAILURE = 'FETCH_BRAND_PAGE_DETAILS_FAILURE';
export const SET_PAGE_TYPE = 'SET_PAGE_TYPE';
export const RESET_BRAND_LANDING_DETAILS = 'RESET_BRAND_LANDING_DETAILS';